export default class Packages {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    // Main packages list banner slider
    if ($(".packages-banner-slider").length > 0) {
      this.PackagesBannerSliderSetup();
    }

    // Hospital-specific packages list banner slider
    if ($(".hospital-packages-banner-slider").length > 0) {
      this.HospitalPackagesBannerSliderSetup();
    }
  }

  /* ===================================
   *  METHODS
   * =================================== */
  PackagesBannerSliderSetup() {
    const $slider = $(".packages-banner-slider");
    const slideCount = $slider.find(".slide-item").length;

    // Only initialize slider if there's more than 1 slide
    if (slideCount > 1) {
      $slider.slick({
        fade: true,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
      });

      $(".packages-banner-slider-holder .slide-next").click(function () {
        $slider.slick("slickNext");
      });

      $(".packages-banner-slider-holder .slide-prev").click(function () {
        $slider.slick("slickPrev");
      });
    }
  }

  HospitalPackagesBannerSliderSetup() {
    const $slider = $(".hospital-packages-banner-slider");
    const slideCount = $slider.find(".slide-item").length;

    // Only initialize slider if there's more than 1 slide
    if (slideCount > 1) {
      $slider.slick({
        fade: true,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
      });

      $(".hospital-packages-banner-slider-holder .slide-next").click(function () {
        $slider.slick("slickNext");
      });

      $(".hospital-packages-banner-slider-holder .slide-prev").click(function () {
        $slider.slick("slickPrev");
      });
    }
  }
}

